import script from "./ProductCardHG.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCardHG.vue?vue&type=script&setup=true&lang=js"

import "./ProductCardHG.vue?vue&type=style&index=0&id=3c66a2bc&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c66a2bc"]])

export default __exports__